import apiFetch from "@/app/auth/apiFetch";

const API_URL = import.meta.env.VITE_API_URL;

export interface Prediction {
  label: string;
  score: number;
}

export interface ClassifyResult {
  predictions: Prediction[];
  top: string;
}

export async function classifyText(
  text: string,
  navigate,
): Promise<ClassifyResult> {
  const res = await apiFetch(
    `${API_URL}/admin/analysis/classify-text`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text }),
    },
    navigate,
  );
  if (!res?.ok) {
    // Le backoffice renvoie déjà des messages génériques (502/503/504/500/422).
    // On exploite le `detail` si disponible pour aider l'admin, sinon message
    // par défaut.
    const detail = await res?.json().catch(() => null);
    const msg =
      typeof detail?.detail === "string"
        ? detail.detail
        : "Échec de la classification";
    throw new Error(msg);
  }
  return res.json();
}
